export class IframeService {
  openDeposit = (
    obj = {
      action: 'openSlider',
      tab: 'deposit',
    },
    target = '*'
  ) => {
    window.top.postMessage(obj, target);
  };

  logout = (key = 'logout', target = '*') => {
    window.parent.postMessage(key, target);
  };

  reloadFrameForRealMoney = (
    obj = {
      action: 'togglePlayMode',
      gameId: '131313',
    },
    target = '*'
  ) => {
    window.top.postMessage(obj, target);
  };

  redirection = (type = null, target = '*') => {
    if (type) {
      window.parent.postMessage('redirectLogin', target);
    } else {
      window.parent.postMessage('redirectHome', target);
    }
  };

  reloadFrame = (target = '*') => {
    window.parent.postMessage('reload', target);
  };

  isInIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  sendLoadedState = (target = '*') => {
    window.parent.postMessage('pgLoaded', target);
  };
}

export const iframeService = new IframeService();
